import type React from "react";
import {SupplierTabPlaceholder} from "../SupplierTabPlaceholder";

export const SupplierOpportunitiesTab: React.FC = () => <SupplierTabPlaceholder title="Opportunities"/>;
